import { render, staticRenderFns } from "./IntegralSetting.vue?vue&type=template&id=18d112fa&scoped=true&"
import script from "./IntegralSetting.vue?vue&type=script&lang=js&"
export * from "./IntegralSetting.vue?vue&type=script&lang=js&"
import style0 from "./IntegralSetting.vue?vue&type=style&index=0&id=18d112fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d112fa",
  null
  
)

export default component.exports